import smapiotWhite from '../images/smapiot_white.svg';
import smapiotGreen from '../images/smapiot_green.svg';
export var images = {
    smapiotWhite: smapiotWhite,
    smapiotGreen: smapiotGreen,
};
//# sourceMappingURL=media.js.map